import styled from 'styled-components';

export const TagYes = styled('span')`
  border-radius: 15px;
  background-color: ${(props) => props.theme.checked};
  color: ${(props) => props.theme.white};
  padding: 2px 6px;
`;

export const Status = styled('div')`
  .news,
  .system,
  .faq {
    border-radius: 15px;
    color: ${(props) => props.theme.white};
    padding: 2px 6px;
    margin-bottom: 2px;
    text-align: center;
  }

  .news {
    background-color: ${(props) => props.theme.statusBlue};
  }

  .system {
    background-color: ${(props) => props.theme.statusRose};
  }

  .faq {
    background-color: ${(props) => props.theme.statusYellow};
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
`;

export const FilterItem = styled.span`
  display: inline-flex;
`;

export const ActionsCell = styled.div`
  display: inline-flex;

  :global(.status-actions) {
      min-width: 160px;
  }
`;

export const CategoryCell = styled.div`
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
